import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Datafields } from 'src/app/models/database/datafield.model';
import { DatasheetSession } from 'src/app/models/database/datasheet-session.model';
import { DatasheetBuilderService } from 'src/app/services/datasheet-builder/datasheet-builder.service';
import { DatafieldsAttributes, SessionAttributes } from 'src/app/services/datasheet/datasheet.service';
import { datafieldComponentRelations } from '../datafield-relations';
import { DatafieldDirective } from '../datafield.directive';
import { IDatafieldComponent } from '../datafield.interface';

@Component({
  selector: 'datasheet-session',
  templateUrl: './datasheet-session.component.html',
  styleUrls: ['./datasheet-session.component.scss']
})
export class DatasheetSessionComponent implements AfterViewInit, OnChanges {

  @Input() datasheetBuilder: boolean = false
  @Input('datasheetSession') datasheetSession: DatasheetSession
  @Input('recordSession') recordSession: SessionAttributes
  @ViewChild(DatafieldDirective) datafieldHost: DatafieldDirective

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetectorRef: ChangeDetectorRef,
    public datasheetBuilderService: DatasheetBuilderService
  ) { }

  ngAfterViewInit(): void {
    if (this.datafieldHost) {
      let viewContainerRef = this.datafieldHost.viewContainerRef;
      viewContainerRef.clear();
      let componentFactory
      if (this.recordSession) {
        let datafields: DatafieldsAttributes = this.recordSession.datafields
        datafields.forEach(datafield => {
          for (const datafieldRelation of datafieldComponentRelations) {
            if (datafieldRelation.id === Number(datafield.type)) {
              componentFactory = this.componentFactoryResolver.resolveComponentFactory(datafieldRelation.component)
              const componentRef = viewContainerRef.createComponent<IDatafieldComponent>(componentFactory)
              componentRef.instance.label = datafield.label
              componentRef.instance.value = datafield.value
              componentRef.instance.session = this.recordSession.session
              if (datafield.list) {
                componentRef.instance.list = datafield.list
              }
              if (datafield.minValue != null && datafield.maxValue != null) {
                componentRef.instance.minValue = datafield.minValue
                componentRef.instance.maxValue = datafield.maxValue
              }
              break
            }
          }
        })
        this.changeDetectorRef.detectChanges()
        return
      }
      let datafields: Datafields = this.datasheetSession.datafield
      datafields.forEach(datafield => {
        for (const datafieldRelation of datafieldComponentRelations) {
          if (datafieldRelation.id === Number(datafield.type)) {
            componentFactory = this.componentFactoryResolver.resolveComponentFactory(datafieldRelation.component)
            const componentRef = viewContainerRef.createComponent<IDatafieldComponent>(componentFactory)
            componentRef.instance.label = datafield.description
            componentRef.instance.session = this.datasheetSession.description
            if (this.datasheetBuilder) {
              componentRef.instance.datafield = datafield
            }
            if (datafield.list) {
              componentRef.instance.list = datafield.list
            }
            if (datafield.minValue != null && datafield.maxValue != null) {
              componentRef.instance.minValue = datafield.minValue
              componentRef.instance.maxValue = datafield.maxValue
            }
            break
          }
        }
      })
      this.changeDetectorRef.detectChanges()
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.datasheetBuilder) {
      this.ngAfterViewInit()
    }
  }
}
